import { createColors } from './createColors';
/**
 * Create colors with specified color map.
 */
export function createColorsFromMap(colormap, shades, alpha) {
    if (shades < colormap.length) {
        throw new Error(`Requires at least ${colormap.length} shades.`);
    }
    const result = [];
    const steps = [];
    for (let i = 0; i < colormap.length; i++) {
        steps.push(Math.round(colormap[i].index * shades));
    }
    for (let i = 0; i < colormap.length - 1; i++) {
        const n = steps[i + 1] - steps[i];
        const from = colormap[i].rgb;
        const to = colormap[i + 1].rgb;
        result.push(...createColors(from, to, n, alpha));
    }
    return result;
}
//# sourceMappingURL=createColorsFromMap.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/color-map/dist-es2015/createColorsFromMap.js
// module id = 1877
// module chunks = 0